export default "__VITE_ASSET__CUJacerr__"